import styled, { keyframes } from "styled-components";

const scroll = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
`;

export const StatsTrack = styled.div`
  display: flex;
  gap: 24px;
  width: max-content;
  animation: ${scroll} 20s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

export const DashboardWrapper = styled.section`
  width: 100%;
  padding: clamp(24px, 3vw, 40px);
`;

export const DashboardGrid = styled.div`
  max-width: 1400px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: stretch;

  > * {
    min-width: 0;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const DashboardLowerGrid = styled(DashboardGrid)`
  margin-top: 40px;
  align-items: start;

  @media (max-width: 640px) {
    margin-top: 24px;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #00585699;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  min-width: 0;
`;

export const CardHeader = styled.div`
  padding: clamp(20px, 3vw, 28px) clamp(20px, 3vw, 32px);

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-width: 0;

  @media (max-width: 480px) {
    padding: 20px 16px 16px;
    gap: 10px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const CardAccent = styled.div`
  width: 6px;
  height: 42px;
  position: relative;
  
  left: -30px;
  background: #fb8e00;
  border-radius: 999px;
`;

export const CardTitle = styled.h2`
  font-size: clamp(26px, 3vw, 34px);
  font-weight: 600;
  color: #115e63;

  @media (max-width: 480px) {
    font-size: 25px;
  }
`;

export const ViewAll = styled.button`
  color: #7a4200;
  height: auto;
  font-size: clamp(17px, 2vw, 20px);
  line-height: 1.2;
  font-weight: 700;
  flex-shrink: 0;
`;

export const UpdateList = styled.div`
  padding: 0 clamp(14px, 2.5vw, 24px) 2px;
  min-width: 0;

  @media (max-width: 480px) {
    padding-inline: 14px;
  }
`;

export const UpdateItem = styled.div`
  border: 0;
  font: inherit;
  text-align: left;

  background: #f2f6fc;
  border-radius: 999px;
  padding: 18px 24px;
  margin-bottom: 14px;

  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};

  @media (max-width: 1024px) {
    align-items: start;
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
    border-radius: 18px;
    padding: 16px 18px;
  }

  @media (max-width: 480px) {
    padding: 14px 16px;
    margin-bottom: 12px;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  align-self: start;
  gap: clamp(24px, 4vw, 64px);
  min-height: 0;

  > * {
    flex: 0 0 auto;
    min-height: 0;
  }

  @media (max-width: 1024px) {
    height: auto;
    gap: 24px;

    > * {
      flex: none;
      min-height: 260px;
    }
  }
`;
export const UpdateTitleWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

export const UpdateTitle = styled.span`
  display: block;
  color: #16376c;
  font-weight: 400;
  line-height: 1.45;

  white-space: normal;
  overflow-wrap: anywhere;

  cursor: pointer;

  @media (max-width: 1024px) {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    overflow-wrap: anywhere;
    word-break: normal;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  left: 0;
  top: calc(100% + 8px);

  background: #16376c;
  color: #fff;

  padding: 8px 12px;
  border-radius: 8px;

  font-size: 13px;
  line-height: 1.4;

  max-width: 380px;
  white-space: normal;
  word-break: break-word;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  transition: all 0.2s ease;

  z-index: 999;

  &::before {
    content: "";
    position: absolute;
    top: -6px;
    left: 20px;

    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #16376c;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
export const CTAButton = styled.button`
  background: #005856;
  color: white;
  width: min(80%, 650px);
  margin-inline: auto;
  padding: 14px 28px;
  border-radius: 999px;
  font-weight: 600;
      margin-top: 6rem;

  @media (max-width: 480px) {
    width: calc(100% - 32px);
    padding: 12px 20px;
  }
`;

export const AppBanner = styled.div`
  background: #005f63;

  color: white;

  border-radius: 24px;

  overflow: hidden;

  position: relative;

  flex: 0 0 260px;
  height: 260px;
  min-height: 260px;
  max-height: 260px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    flex-basis: auto;
    height: auto;
    min-height: 0;
    max-height: none;
    aspect-ratio: 1310 / 600;
    border-radius: 18px;
    background: transparent;

    img {
      object-fit: contain;
    }
  }
`;

export const StoreButtons = styled.div`
  display: flex;
  gap: 16px;

  margin-top: 20px;
`;
